var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        title: _vm.title,
        footer: null,
        width: "80%",
        closable: false,
        keyboard: false,
        maskClosable: false
      },
      model: {
        value: _vm.visible,
        callback: function($$v) {
          _vm.visible = $$v
        },
        expression: "visible"
      }
    },
    [
      _c("a-spin", { attrs: { spinning: _vm.loading } }, [
        _c("div", {
          staticClass: "contract-box",
          domProps: { innerHTML: _vm._s(_vm.artcCntnt) }
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "spaceCenter" },
          [
            _c(
              "a-button",
              {
                staticStyle: { margin: "30px 5px", width: "90px" },
                attrs: { type: "primary" },
                on: {
                  click: function($event) {
                    return _vm.okModal()
                  }
                }
              },
              [_vm._v("签署")]
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-67f33f65", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67f33f65","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sign/user-service.vue
// module id = mDLi
// module chunks = 1